var _path, _polygon, _path2, _polygon2, _path3, _polygon3, _path4, _polygon4, _path5, _path6, _path7, _circle, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMockupLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 611.20467,
    height: 472.27086,
    viewBox: "0 0 611.20467 472.27086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "uuid-79a026f0-2fc2-4045-889d-ae4ea067a71d-55-389",
    d: "m305.34325,234.85979c1.97417,7.91176-.67063,15.33375-5.8999,16.58457-5.2293,1.24327-11.06893-4.15932-13.0431-12.07108-.83638-3.14963-.87406-6.45751-.1055-9.62974l-7.92682-33.62876,16.47152-3.36062,6.06567,33.5082c2.17763,2.47902,3.69969,5.43274,4.43813,8.60499h0v-.00757Z",
    fill: "#ec9c9f",
    strokeWidth: 0
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "236.2698 427.1533 237.28703 449.1932 236.2698 455.289 239.82633 462.40959 267.78122 465.45372 269.31083 452.24487 254.57235 444.61945 254.14285 432.16405 236.2698 427.1533",
    fill: "#ec9c9f",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m265.7543,460.37513l-1.52206,2.03446-29.27352-8.43922s1.31863,13.01298,1.31863,15.55227,48.28434,2.53929,55.5481,1.52209,4.93542-7.62543,4.93542-7.62543l-30.1325-14.26377-.87406,11.2121h0v.0075Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "163.44393 410.9304 157.34811 432.13393 154.43959 437.58927 155.53217 445.46336 181.03817 457.30088 186.71204 445.26745 175.18347 433.33201 182.41708 414.5849 163.44393 410.9304",
    fill: "#ec9c9f",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m180.73677,451.838l-2.09473,1.43917-25.03884-17.36065s-2.91605,12.74923-3.7223,15.1529,44.93127,17.85798,52.14227,19.22182c7.211,1.36384,7.11305-5.64372,7.11305-5.64372l-23.98394-23.15507-4.41552,10.34555h0Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "238.24397 63.26499 239.31395 80.59551 206.94354 82.23815 216.96511 59.39954 238.24397 63.26499",
    fill: "#ec9c9f",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m240.13526,78.00347c-8.6728,3.873-22.55228,2.81056-38.27786,0l-2.45641,108.95625s49.19609,9.89345,66.11218-8.35632l-8.89885-89.01862-16.47155-11.57378h0v-.00754h-.00752Z",
    fill: "#3b82f6",
    strokeWidth: 0
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "260.17086 181.27081 190.71313 188.13518 156.4439 420.85404 182.70341 420.85404 227.67235 261.39056 231.23642 442.10273 255.2731 442.10273 275.74573 220.88236 260.17086 181.27081",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m211.72828,71.32747l-23.33593,13.81168c-8.83856,5.2293-13.00542,15.79339-10.11953,25.64917l18.03128,61.59871s-29.36394,50.45444-19.82461,54.90011c21.44463,9.99895,53.44583,7.56516,53.44583,7.56516l-7.15072-120.79375-11.04633-42.73104h0v-.00002s.00001-.00002.00001-.00001Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m239.12558,77.54385l26.3876,10.24761,6.23145,76.11114,17.45109,61.3199c-29.55986,10.79014-26.80204,5.76428-26.80204,5.76428l-4.89776-105.80662-18.37036-47.63634h0s.00002.00002.00002.00002Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m277.66715,223.93403l-.09042-.41442-26.96781-124.7421c-.7535-3.48871.21098-6.97742,2.6448-9.58453,2.43382-2.60711,5.8547-3.80518,9.3811-3.2928,4.35524.63294,7.83641,3.80518,8.87624,8.07753l29.62767,121.77331-23.47155,8.19055h0l-.00002-.00754Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 224.19872,
    cy: 41.60937,
    r: 26.25951,
    fill: "#ec9c9f",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m236.69176,7.58126c5.78688,2.03445,9.09476,3.19484,12.12383,6.11843,5.1238,4.93543,5.96774,11.52857,6.75136,17.65453.61788,4.79227,1.40904,10.98604-1.4015,18.06896-.95694,2.41874-5.60605,13.17873-14.49735,14.54257-1.74813.26372-5.84718.33907-4.66417-.53499,10.94083-8.07753,15.605-12.95269,15.22073-25.39299-.24113-7.73092-12.05602-16.07971-19.07111-17.57918-2.95373-.63294-6.88701-.05274-9.71264,2.2605-5.8999,4.83748-5.64372,24.858-11.86011,29.03993-2.55437,1.71798-.85146-10.39078-2.65233-8.43168-3.55653,3.873-1.27342,9.81058-.63294,12.07109,3.02908,10.72232,8.74062,11.76969,11.70187,20.93226,3.19484,9.88594-.82886,19.19167-1.77825,21.39943-1.65771,3.84286-4.50593,10.42845-11.00865,13.59315-8.25838,4.01616-14.76863-1.21314-18.60394,3.27019-2.14748,2.50163-.98708,5.15394-4.86008,12.94514-1.26588,2.53929-1.89883,3.81271-2.45641,3.76751-2.65233-.21098-6.93975-21.42957,0-41.18637,2.91605-8.28851,5.76428-16.41125,13.41232-22.76327,4.0463-3.36061,7.43705-4.56621,8.40153-8.49195,1.37891-5.60605-4.3477-7.99465-5.49302-16.83321-.78364-6.04308-1.3337-14.69327.79871-20.2315,2.01938-5.23683,3.76751-9.78044,8.34879-13.89456,1.10012-.98709,9.97635-7.71585,19.39511-7.90423,4.33263-.09042,7.51995,5.82456,12.54579,7.58776h-.00754s0-.00753,0-.00752Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m606.33904,360.69947H243.50619c-2.40735,0-4.36564-1.95828-4.36564-4.36564v-224.10263c0-2.40735,1.95828-4.36564,4.36564-4.36564h362.83285c2.40735,0,4.36563,1.95828,4.36563,4.36564v224.10264c0,2.40735-1.95828,4.36564-4.36563,4.36564h0Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m606.33904,360.69947H243.50619c-2.40735,0-4.36564-1.95828-4.36564-4.36564v-224.10263c0-2.40735,1.95828-4.36564,4.36564-4.36564h362.83285c2.40735,0,4.36563,1.95828,4.36563,4.36564v224.10264c0,2.40735-1.95828,4.36564-4.36563,4.36564h0Z",
    fill: "none",
    stroke: "#2f2e43",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m267.75972,147.26839h-16.4924c-2.40735,0-4.36564-1.95828-4.36564-4.36564v-1.94028c0-2.40735,1.95828-4.36564,4.36564-4.36564h16.4924c2.40735,0,4.36564,1.95828,4.36564,4.36564v1.94028c0,2.40735-1.95828,4.36564-4.36564,4.36564Z",
    fill: "#3b82f6",
    strokeWidth: 0
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m559.77225,147.26839h-9.70143c-2.40735,0-4.36563-1.95828-4.36563-4.36564v-1.94028c0-2.40735,1.95828-4.36564,4.36563-4.36564h9.7014c2.40735,0,4.36563,1.95828,4.36563,4.36564v1.94028c0,2.40735-1.95828,4.36564-4.36563,4.36564h.00003Z",
    fill: "#d7d7d7",
    strokeWidth: 0
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m494.77277,205.47687c-1.33772,0-2.42535,1.08809-2.42535,2.42536v1.94029c0,1.33726,1.08763,2.42536,2.42535,2.42536h56.26819c1.33772,0,2.42535-1.08809,2.42535-2.42536v-1.94029c0-1.33726-1.08763-2.42536-2.42535-2.42536h-56.26819Z",
    fill: "#d7d7d7",
    strokeWidth: 0
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m476.3401,304.43128h-225.07279c-2.40735,0-4.36564-1.95828-4.36564-4.36564v-142.61076c0-2.40735,1.95828-4.36564,4.36564-4.36564h225.07277c2.40735,0,4.36563,1.95828,4.36563,4.36564v142.61078c0,2.40735-1.95828,4.36564-4.36564,4.36564h.00003Z",
    fill: "#d7d7d7",
    strokeWidth: 0
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m477.31024,351.9682h-103.80512c-2.40735,0-4.36564-1.95828-4.36564-4.36564v-33.95495c0-2.40735,1.95828-4.36564,4.36564-4.36564h103.80512c2.40736,0,4.36564,1.95828,4.36564,4.36564v33.95495c0,2.40735-1.95828,4.36564-4.36564,4.36564Z",
    fill: "#d7d7d7",
    strokeWidth: 0
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m354.65558,351.73041h-103.80512c-2.40735,0-4.36564-1.95828-4.36564-4.36564v-33.95495c0-2.40735,1.95828-4.36564,4.36564-4.36564h103.80513c2.40736,0,4.36564,1.95828,4.36564,4.36564v33.95495c0,2.40735-1.95829,4.36564-4.36564,4.36564h-.00001Z",
    fill: "#d7d7d7",
    strokeWidth: 0
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m598.57789,309.282c2.40735,0,4.36563,1.95828,4.36563,4.36564v33.95495c0,2.40735-1.95828,4.36564-4.36563,4.36564h-103.80512c-2.40735,0-4.36563-1.95828-4.36563-4.36564v-33.95495c0-2.40735,1.95828-4.36564,4.36563-4.36564",
    fill: "#d7d7d7",
    strokeWidth: 0
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m494.77277,220.99913c-1.33772,0-2.42535,1.08809-2.42535,2.42536s1.08763,2.42536,2.42535,2.42536h86.34258c1.33772,0,2.42535-1.08809,2.42535-2.42536s-1.08763-2.42536-2.42535-2.42536h-86.34258Z",
    fill: "#d7d7d7",
    strokeWidth: 0
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m494.77277,234.58111c-1.33772,0-2.42535,1.08809-2.42535,2.42536s1.08763,2.42536,2.42535,2.42536h86.34258c1.33772,0,2.42535-1.08809,2.42535-2.42536s-1.08763-2.42536-2.42535-2.42536h-86.34258Z",
    fill: "#d7d7d7",
    strokeWidth: 0
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m494.77277,247.19295c-1.33772,0-2.42535,1.0881-2.42535,2.42536s1.08763,2.42535,2.42535,2.42535h56.26819c1.33772,0,2.42535-1.08809,2.42535-2.42535s-1.08763-2.42536-2.42535-2.42536",
    fill: "#d7d7d7",
    strokeWidth: 0
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m579.17507,147.26839h-9.7014c-2.40735,0-4.36563-1.95828-4.36563-4.36564v-1.94028c0-2.40735,1.95828-4.36564,4.36563-4.36564h9.7014c2.40735,0,4.36563,1.95828,4.36563,4.36564v1.94028c0,2.40735-1.95828,4.36564-4.36563,4.36564Z",
    fill: "#d7d7d7",
    strokeWidth: 0
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m598.57789,147.26839h-9.70143c-2.40735,0-4.36563-1.95828-4.36563-4.36564v-1.94028c0-2.40735,1.95828-4.36564,4.36563-4.36564h9.7014c2.40735,0,4.36563,1.95828,4.36563,4.36564v1.94028c0,2.40735-1.95828,4.36564-4.36563,4.36564h.00003Z",
    fill: "#d7d7d7",
    strokeWidth: 0
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "uuid-68265fee-faa5-4bbc-a8c0-9ee61ef7b954-56-390",
    d: "m237.96518,159.66038c8.10768-.85146,15.09263,2.79549,15.59748,8.15288.50486,5.35738-5.6588,10.38324-13.774,11.2347-3.24005.38428-6.51026-.03768-9.55439-1.23574l-34.40486,3.1647-1.03229-16.78047,34.02811-1.34123c2.75782-1.8084,5.89238-2.90851,9.13997-3.20238h0l-.00002.00754Z",
    fill: "#ec9c9f",
    strokeWidth: 0
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m196.04792,85.93031h0c-8.32619-1.17546-16.13999,4.30249-17.87305,12.53073-6.03554,28.71593-16.87842,89.87761.14317,90.90237,22.25842,1.3337,43.62018-4.00863,43.62018-4.00863l-5.34232-30.7127-17.36067-1.77826,10.20994-47.76443c1.9365-9.07215-4.21961-17.88058-13.40478-19.16907h.00753Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 471.52086,
    x2: 519.42586,
    y2: 471.52086,
    fill: "none",
    stroke: "#090814",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMockupLogo);
export default __webpack_public_path__ + "static/media/mockup-logo.044fe1ae9fea565e6bb029b948044f52.svg";
export { ForwardRef as ReactComponent };